import { Delete } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useMemo } from "react";
import RequeridoLabel from "../../../../../../../commons/labels/RequeridoLabel";
import { tableConfig, tableStyles } from "../../../../../../../commons/table/tableConfig";
import { StyledResolucion } from "../../../../../../../styled/Prevencion";

const EquipoRadiologicoTable = ({
  data,
  handleOpenForm,
  handleDeleteEquipos,
  handleGoBack,
  handleNextStep,
  stepper,
}) => {

  const columns = useMemo(
    () => [
      {
        accessorFn: (row) => row.equipoRadiologicoData.marca,
        header: "Marca",
        id: "marca",
        size: 150,
        enableColumnFilter: false,
      },
      {
        accessorFn: (row) => row.equipoRadiologicoData.modelo,
        header: "Modelo",
        id: "modelo",
        size: 150,
        enableColumnFilter: false,

      },
      {
        accessorFn: (row) => row.equipoRadiologicoData.nombreTipoEquipoRadiologico,
        header: "Tipo",
        id: "tipo",
        size: 150,
        enableColumnFilter: false,
      },
      {
        accessorFn: (row) => row.equipoRadiologicoData.nombreCaracteristicaEquipoRadiologico,
        header: "Característica",
        id: "caracteristica",
        size: 200,
        enableColumnFilter: false,
      },
      {
        accessorFn: (row) => row.equipoRadiologicoData.nombreTipoRadiacion,
        header: "Tipo de Radiación",
        id: "tipoRadiacion",
        size: 150,
        enableColumnFilter: false,
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    ...tableConfig,
    columns,
    data,
    enableRowSelection: true,
    enableColumnFilters: false,
    enableColumnActions: false,
    enableHiding: false,
    positionActionsColumn: 'last',
    enableRowActions: true,  // Make sure to enable row actions
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: 'Operaciones',
        size: 120,
        muiTableHeadCellProps: {
          align: 'left',
          sx: {
            ...tableStyles.headerStyle,
            verticalAlign: 'top'
          }
        }
      },
    },
    initialState: {
      ...tableConfig.initialState,
      density: 'compact',
      pagination: {
        pageSize: 5,
        pageIndex: 0
      },
      columnVisibility: {
        'mrt-row-actions': true,
      }
    },
    renderTopToolbarCustomActions: () => (
      <StyledResolucion.HeaderContainer>
        <StyledResolucion.TableTitle>
          Equipos Radiológicos
        </StyledResolucion.TableTitle>
        <RequeridoLabel text='Completa este paso solo si es necesario. De lo contrario, continúe realizando click en "Paso Siguiente"' />
      </StyledResolucion.HeaderContainer>
    ),
    renderToolbarAlertBannerContent: ({ groupedAlert, selectedAlert, table }) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginLeft: 1,
        }}>
        {selectedAlert}
        <Tooltip title="Eliminar seleccionados">
          <IconButton
            onClick={() => {
              const selectedRows = table.getSelectedRowModel().rows;
              handleDeleteEquipos(selectedRows);
              table.resetRowSelection();
            }}
          >
            <Delete />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    renderRowActions: ({ row }) => (
      <div style={{ display: 'flex', gap: '8px' }}>
        <IconButton
          onClick={() => handleOpenForm({ ...row.original, index: row.index })}
          size="small"
        >
          <EditIcon />
        </IconButton>
      </div>
    ),
    muiBottomToolbarProps: {
      sx: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
    },
    positionPagination: 'bottom',
    renderBottomToolbarCustomActions: () => {
      return (
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <Button
            color="primary"
            onClick={() => handleOpenForm()}
            size="small"
          >
            Agregar
          </Button>
        </div>
      );
    },
  });

  return (
    <>
      <StyledResolucion.TableContainer>
        <MaterialReactTable table={table} />
      </StyledResolucion.TableContainer>

      {stepper ?? ""}
      <StyledResolucion.ButtonContainer>
        <StyledResolucion.CancelButton onClick={handleGoBack}>
          PASO ANTERIOR
        </StyledResolucion.CancelButton>
        <StyledResolucion.AddButton
          color="primary"
          variant="contained"
          onClick={handleNextStep}
        >
          PASO SIGUIENTE
        </StyledResolucion.AddButton>
      </StyledResolucion.ButtonContainer>
    </>
  );
};

export default EquipoRadiologicoTable;